import React, { useState } from "react";
// import { createAction } from "@reduxjs/toolkit";
// import store from "../app/store";
import { TableContext } from "../index";
import { debug } from "../utils";
import { useHistory } from "react-router-dom";
import MlDetectionTableHeader from "./MlDetectionTableHeader";
import MlDetectionTable from "./MlDetectionTable";
import PaginationManager from "../view/PaginationManager";
import * as mlDetectionService from "./mlDetectionService";
// import * as configActionService from "./configActionService";
// import { ACTION_RESULTS_CHANGED, ACTION_RESULTS_CHANGED_VIEW_MODE } from "./MlDetectionPageReducer";

function MlDetectionTableSection(props) {

    const history = useHistory();

    // const initTableConfig = {
    //     selected: [],
    //     isLoading: true,
    //     results: [],
    //     allResults: [],
    //     viewMode: "config",
    //     loadError: null,
    // }

    const initTableConfig = {
        selected: [],
        isLoading: true,
        results: [],
        allResults: [],
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        //alert (config)
        setTableConfig(config);
    }

    // useEffect(() => {
    //     store.dispatch(createAction(ACTION_RESULTS_CHANGED)({results: []}));
    //     store.dispatch(createAction(ACTION_RESULTS_CHANGED_VIEW_MODE)({viewMode: "config"}));
    // }, []);

    // const changeTableConfig = (config) => {
    //     debug("Table config changed:", config);
    //     //alert (config)
    //     setTableConfig(config);
    // }

    // const getPage = (pageNumber, pageSize) => {
    //     return tableConfig.viewMode === "config"
    //         ? configActionService.listPageable(pageNumber, pageSize)
    //         : mlDetectionService.listPageable(pageNumber, pageSize);
    // };

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_analysis-card-v2">
                            <MlDetectionTableHeader />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <MlDetectionTable />
                                            <PaginationManager
                                                getPage={mlDetectionService.listPageable}
                                                blocked={tableConfig.filtersLoading} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default MlDetectionTableSection;
